import { Component, OnInit } from '@angular/core';

import { NotificationService, PbasService } from '../../../../../shared/services';
import { ModalService } from '../../../../../shared/modules/modal';
import {
  ClosableModalWithErrorResponseModel
} from '../../../../../shared/components/base/closable-modal-with-error-response-model';
import { TinyTextEditor } from '../../../../../shared/constants';
import {
  CharacterizeTestedPartyModalPayload,
  CharacterizeTestedPartyDescription,
  CharacterizeTestedPartyDescriptionErrorResponse
} from '../../../../../shared/models';

@Component({
  selector: 'provide-description-modal',
  templateUrl: './provide-description-modal.component.html',
})
export class ProvideDescriptionModalComponent
  extends ClosableModalWithErrorResponseModel<CharacterizeTestedPartyDescriptionErrorResponse> implements OnInit {
  isDescriptionInputTouched = false;

  tinyInit = TinyTextEditor.INIT;

  data: CharacterizeTestedPartyModalPayload;
  characterizeTestedPartyDescription = new CharacterizeTestedPartyDescription();

  constructor(
    protected modalService: ModalService,
    protected notificationService: NotificationService,
    private _pbasService: PbasService
  ) {
    super(notificationService, modalService);
    this.validationErrors = new CharacterizeTestedPartyDescriptionErrorResponse();
  }

  ngOnInit() {
    this.listenForErrorMessages();
    this.characterizeTestedPartyDescription.description = this.data.characterization.description;
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    if (this.data.characterization.characterizationId) {
      this.updateDescription();
      return;
    }
    this.createDescription();
  }

  setDescriptionInputTouchedState(touched = true): void {
    this.isDescriptionInputTouched = touched;
  }

  private createDescription(): void {
    this._pbasService
      .saveTestedPartyCharacterizationDescription(
        this.data.testedParty.pba.pbaId,
        this.characterizeTestedPartyDescription)
      .subscribe(() => {
        this.success();
        this.close();
      }
      );
  }

  private updateDescription(): void {
    this._pbasService
      .updateTestedPartyCharacterizationDescription(
        this.data.testedParty.pba.pbaId,
        this.characterizeTestedPartyDescription)
      .subscribe(() => {
        this.success();
        this.close();
      }
      );
  }

}
